export const companyList = [
    {
      "displayName": "2nd.MD",
      "code": "2ndmd"
    },
    {
      "displayName": "3M Company",
      "code": "3m"
    },
    {
      "displayName": "ABB",
      "code": "abb"
    },
    {
      "displayName": "Abbott",
      "code": "abbott"
    },
    {
      "displayName": "Abbvie",
      "code": "abbvie"
    },
    {
      "displayName": "ABM Industries",
      "code": "abm_industries"
    },
    {
      "displayName": "Accolade",
      "code": "accolade"
    },
    {
      "displayName": "ADP",
      "code": "adp"
    },
    {
      "displayName": "Advance Auto Parts",
      "code": "advance_auto_parts"
    },
    {
      "displayName": "Advocate Aurora Health",
      "code": "advocate_aurora_health"
    },
    {
      "displayName": "Advocate Health Care",
      "code": "advocate_health_care"
    },
    {
      "displayName": "Air Products & Chemicals",
      "code": "airproducts"
    },
    {
      "displayName": "Alameda County",
      "code": "alameda_county"
    },
    {
      "displayName": "Aldi",
      "code": "aldi"
    },
    {
      "displayName": "Allegis Group",
      "code": "allegis_group"
    },
    {
      "displayName": "Allstate Corporation",
      "code": "allstate"
    },
    {
      "displayName": "Amazon",
      "code": "amazon"
    },
    {
      "displayName": "American Airlines",
      "code": "american_airlines"
    },
    {
      "displayName": "American Family Insurance",
      "code": "american_family_insurance"
    },
    {
      "displayName": "AmeriGas",
      "code": "amerigas"
    },
    {
      "displayName": "Amphenol Corporation",
      "code": "amphenol"
    },
    {
      "displayName": "AMR Holdco",
      "code": "amr_holdco"
    },
    {
      "displayName": "Anthem",
      "code": "anthem"
    },
    {
      "displayName": "Apple",
      "code": "apple"
    },
    {
      "displayName": "Aramark",
      "code": "aramark"
    },
    {
      "displayName": "Ascension",
      "code": "ascension"
    },
    {
      "displayName": "Assisted Living Concepts",
      "code": "assisted_living_concepts"
    },
    {
      "displayName": "Assurant",
      "code": "assurant"
    },
    {
      "displayName": "AT&T",
      "code": "att"
    },
    {
      "displayName": "Atrium Health",
      "code": "atrium_health"
    },
    {
      "displayName": "Autonation",
      "code": "autonation"
    },
    {
      "displayName": "Autozone",
      "code": "autozone"
    },
    {
      "displayName": "Bacardi Limited",
      "code": "bacardi_limited"
    },
    {
      "displayName": "Banner Health",
      "code": "banner_health"
    },
    {
      "displayName": "Bayada Home Health Care",
      "code": "bayada_home_health_care"
    },
    {
      "displayName": "BayCare Health System",
      "code": "baycare_health_system"
    },
    {
      "displayName": "Becton Dickinson & Company",
      "code": "becton_dickinson_and"
    },
    {
      "displayName": "Best Buy",
      "code": "best_buy"
    },
    {
      "displayName": "BJC Health System",
      "code": "bjc_health_system"
    },
    {
      "displayName": "Blue Cross Blue Shield Illinois",
      "code": "blue_cross_blue_shield_illinois"
    },
    {
      "displayName": "BNSF Railway",
      "code": "bnsf_railway"
    },
    {
      "displayName": "Boehringer Ingelheim USA Corporation",
      "code": "boehringer_ingelheim_usa"
    },
    {
      "displayName": "Boeing Company",
      "code": "boeing"
    },
    {
      "displayName": "Brightside",
      "code": "brightside"
    },
    {
      "displayName": "Brookdale Senior Living",
      "code": "brookdale_senior_living"
    },
    {
      "displayName": "C&S Wholesale Grocers",
      "code": "cs_wholesale_grocers"
    },
    {
      "displayName": "C.H. Robinson Worldwide",
      "code": "ch_robinson_worldwide"
    },
    {
      "displayName": "Cablofil",
      "code": "legrand"
    },
    {
      "displayName": "Caesars Entertainment Corporation",
      "code": "caesars_entertainment"
    },
    {
      "displayName": "Cardinal Health",
      "code": "cardinal_health"
    },
    {
      "displayName": "Cargill",
      "code": "cargill"
    },
    {
      "displayName": "Carrier Corporation",
      "code": "carrier"
    },
    {
      "displayName": "Caterpillar",
      "code": "caterpillar"
    },
    {
      "displayName": "Centene Corporation",
      "code": "centene"
    },
    {
      "displayName": "Centurylink",
      "code": "centurylink"
    },
    {
      "displayName": "Charter Communications",
      "code": "charter_communications"
    },
    {
      "displayName": "Cheesecake Factory",
      "code": "cheesecake_factory"
    },
    {
      "displayName": "Chenmed LLC",
      "code": "chenmed"
    },
    {
      "displayName": "Chevron Corporation",
      "code": "chevron"
    },
    {
      "displayName": "Childrens Hospital Medical Center",
      "code": "childrens_hospital_medical_center"
    },
    {
      "displayName": "Chipotle Mexican Grill",
      "code": "chipotle_mexican_grill"
    },
    {
      "displayName": "Chobani",
      "code": "chobani"
    },
    {
      "displayName": "Cigna",
      "code": "cigna"
    },
    {
      "displayName": "Cisco Systems",
      "code": "cisco_systems"
    },
    {
      "displayName": "Cleveland Clinic Foundation",
      "code": "cleveland_clinic_foundation"
    },
    {
      "displayName": "Colgate Palmolive Company",
      "code": "colgate_palmolive"
    },
    {
      "displayName": "Comcast Corporation",
      "code": "comcast"
    },
    {
      "displayName": "CommonSpirit Health",
      "code": "commonspirit_health"
    },
    {
      "displayName": "Community Health Systems",
      "code": "community_health_systems"
    },
    {
      "displayName": "Connectrac",
      "code": "legrand"
    },
    {
      "displayName": "Corning",
      "code": "corning"
    },
    {
      "displayName": "Corteva",
      "code": "corteva"
    },
    {
      "displayName": "Costco Wholesale Corporation",
      "code": "costco_wholesale"
    },
    {
      "displayName": "Covenant Care California, LLC",
      "code": "covenant_care_california"
    },
    {
      "displayName": "Covenant Health in West Texas and New Mexico",
      "code": "providence"
    },
    {
      "displayName": "Cracker Barrel Old Country Store",
      "code": "cracker_barrel_old_country_store"
    },
    {
      "displayName": "Cushman & Wakefield",
      "code": "cushman_and_wakefield"
    },
    {
      "displayName": "CVS Health",
      "code": "cvs_health"
    },
    {
      "displayName": "Danaher Corporation",
      "code": "danaher"
    },
    {
      "displayName": "Davita",
      "code": "davita"
    },
    {
      "displayName": "Dell",
      "code": "dell"
    },
    {
      "displayName": "Dollar General Corporation",
      "code": "dollar_general"
    },
    {
      "displayName": "Dollar Tree",
      "code": "dollar_tree"
    },
    {
      "displayName": "Domino's Pizza",
      "code": "dominos_pizza"
    },
    {
      "displayName": "DuPont",
      "code": "dupont"
    },
    {
      "displayName": "Eaton Corporation",
      "code": "eaton"
    },
    {
      "displayName": "eBay",
      "code": "ebay"
    },
    {
      "displayName": "Ecolab",
      "code": "ecolab"
    },
    {
      "displayName": "Elder Care Alliance",
      "code": "elder_care_alliance"
    },
    {
      "displayName": "Emerson Electric Company",
      "code": "emerson_electric"
    },
    {
      "displayName": "Ensign Group",
      "code": "ensign_group"
    },
    {
      "displayName": "EWS",
      "code": "legrand"
    },
    {
      "displayName": "Exelon Corporation",
      "code": "exelon"
    },
    {
      "displayName": "Farmers Group",
      "code": "farmers_group"
    },
    {
      "displayName": "Fedex Corporation",
      "code": "fedex"
    },
    {
      "displayName": "Finelite",
      "code": "legrand"
    },
    {
      "displayName": "First American Financial Corporation",
      "code": "first_american_financial"
    },
    {
      "displayName": "First Solar",
      "code": "first_solar"
    },
    {
      "displayName": "Five Below",
      "code": "fivebelow"
    },
    {
      "displayName": "Flowers Foods",
      "code": "flowers_foods"
    },
    {
      "displayName": "Ford Motor Company",
      "code": "ford_motor"
    },
    {
      "displayName": "Gallagher",
      "code": "gallagher"
    },
    {
      "displayName": "GE Healthcare",
      "code": "ge_healthcare"
    },
    {
      "displayName": "General Electric Company",
      "code": "general_electric"
    },
    {
      "displayName": "General Mills",
      "code": "general_mills"
    },
    {
      "displayName": "General Motors Company",
      "code": "general_motors"
    },
    {
      "displayName": "Genesis Healthcare",
      "code": "genesis_healthcare"
    },
    {
      "displayName": "GlobalFoundries US",
      "code": "globalfoundries_us"
    },
    {
      "displayName": "Guitar Center",
      "code": "guitar_center"
    },
    {
      "displayName": "Hartford Financial Services Group",
      "code": "hartford_financial_services_group"
    },
    {
      "displayName": "HCA Healthcare",
      "code": "hca_healthcare"
    },
    {
      "displayName": "HCR ManorCare",
      "code": "hcr_manorcare"
    },
    {
      "displayName": "Health Care Service Corporation (HCSC)",
      "code": "health_care_service"
    },
    {
      "displayName": "Healthcare Services Group",
      "code": "healthcare_services_group"
    },
    {
      "displayName": "HEB Grocery Company",
      "code": "heb_grocery"
    },
    {
      "displayName": "Hershey Company",
      "code": "hershey"
    },
    {
      "displayName": "Hobby Lobby Stores",
      "code": "hobby_lobby_stores"
    },
    {
      "displayName": "Home Depot",
      "code": "home_depot"
    },
    {
      "displayName": "HP",
      "code": "hp"
    },
    {
      "displayName": "Humana",
      "code": "humana"
    },
    {
      "displayName": "Hy-Vee",
      "code": "hy_vee"
    },
    {
      "displayName": "Illinois Tool Works",
      "code": "illinois_tool_works"
    },
    {
      "displayName": "Independence Blue Cross",
      "code": "independence_blue_cross"
    },
    {
      "displayName": "Intel Corporation",
      "code": "intel"
    },
    {
      "displayName": "Interim Healthcare",
      "code": "interim_healthcare"
    },
    {
      "displayName": "International Paper Company",
      "code": "international_paper"
    },
    {
      "displayName": "Johnson & Johnson",
      "code": "johnson_and_johnson"
    },
    {
      "displayName": "Kadlec Regional Medical Center",
      "code": "providence"
    },
    {
      "displayName": "Kaiser Permanente",
      "code": "kaiser_permanente"
    },
    {
      "displayName": "Kellogg Company",
      "code": "kellogg"
    },
    {
      "displayName": "Keurig Dr Pepper",
      "code": "keurig_dr_pepper"
    },
    {
      "displayName": "Kindercare Education LLC",
      "code": "kindercare_education"
    },
    {
      "displayName": "Kindred Healthcare",
      "code": "kindred_healthcare"
    },
    {
      "displayName": "Kohl's Corporation",
      "code": "kohls"
    },
    {
      "displayName": "Kroger Company",
      "code": "kroger"
    },
    {
      "displayName": "Labcorp",
      "code": "labcorp"
    },
    {
      "displayName": "Las Vegas Sands Corporation",
      "code": "las_vegas_sands"
    },
    {
      "displayName": "Legrand",
      "code": "legrand"
    },
    {
      "displayName": "Leidos Holdings",
      "code": "leidos_holdings"
    },
    {
      "displayName": "LKQ Corporation",
      "code": "lkq"
    },
    {
      "displayName": "Lockheed Martin Corporation",
      "code": "lockheed_martin"
    },
    {
      "displayName": "Lowes Companies",
      "code": "lowes_companies"
    },
    {
      "displayName": "Lululemon Athletica",
      "code": "lululemon_athletica"
    },
    {
      "displayName": "Lyondellbasell Industries",
      "code": "lyondellbasell_industries"
    },
    {
      "displayName": "Mcdonalds Corporation",
      "code": "mcdonalds"
    },
    {
      "displayName": "McKesson Corporation",
      "code": "mckesson"
    },
    {
      "displayName": "Meijer",
      "code": "meijer"
    },
    {
      "displayName": "Memorial Sloan Kettering Cancer Center",
      "code": "memorial_sloan_kettering_cancer_center"
    },
    {
      "displayName": "Menzies Aviation USA",
      "code": "menzies_aviation_usa"
    },
    {
      "displayName": "Merck & Co",
      "code": "merck_and_co"
    },
    {
      "displayName": "Mercy Health",
      "code": "mercy_health"
    },
    {
      "displayName": "MGM Resorts International",
      "code": "mgm_resorts_international"
    },
    {
      "displayName": "Mondelez International",
      "code": "mondelez_international"
    },
    {
      "displayName": "Monsanto Company",
      "code": "monsanto"
    },
    {
      "displayName": "Mount Sinai Health System",
      "code": "mount_sinai_health_system"
    },
    {
      "displayName": "MV Transportation",
      "code": "mv_transportation"
    },
    {
      "displayName": "NewYork-Presbyterian Hospital",
      "code": "newyork_presbyterian_hospital"
    },
    {
      "displayName": "Nike",
      "code": "nike"
    },
    {
      "displayName": "Nordstrom",
      "code": "nordstrom"
    },
    {
      "displayName": "Northwell Health",
      "code": "northwell_health"
    },
    {
      "displayName": "NortonLifeLock",
      "code": "nortonlifelock"
    },
    {
      "displayName": "Nvidia Corporation",
      "code": "nvidia"
    },
    {
      "displayName": "OhioHealth Corporation",
      "code": "ohiohealth"
    },
    {
      "displayName": "Oneok",
      "code": "oneok"
    },
    {
      "displayName": "Pacific Medical Centers",
      "code": "providence"
    },
    {
      "displayName": "Panda Restaurant Group",
      "code": "panda_restaurant_group"
    },
    {
      "displayName": "Panera Bread Company",
      "code": "panera_bread"
    },
    {
      "displayName": "Parker Hannifin Corporation",
      "code": "parker_hannifin"
    },
    {
      "displayName": "Partners Healthcare",
      "code": "partners_healthcare"
    },
    {
      "displayName": "Pass and Seymour",
      "code": "legrand"
    },
    {
      "displayName": "Pepsico",
      "code": "pepsico"
    },
    {
      "displayName": "Petco Animal Supplies",
      "code": "petco_animal_supplies"
    },
    {
      "displayName": "Petsmart",
      "code": "petsmart"
    },
    {
      "displayName": "PG&E Corporation",
      "code": "pge"
    },
    {
      "displayName": "Phillips 66 Partners LP",
      "code": "phillips_66_partners_lp"
    },
    {
      "displayName": "Precision Castparts Corp",
      "code": "precision_castparts_corp"
    },
    {
      "displayName": "Procter & Gamble Company",
      "code": "procter_and_gamble"
    },
    {
      "displayName": "Progressive Corporation",
      "code": "progressive"
    },
    {
      "displayName": "Promedica Health System",
      "code": "promedica_health_system"
    },
    {
      "displayName": "Providence Health & Services",
      "code": "providence"
    },
    {
      "displayName": "Publix Super Markets",
      "code": "publix_super_markets"
    },
    {
      "displayName": "Qualcomm",
      "code": "qualcomm"
    },
    {
      "displayName": "Quest Diagnostics",
      "code": "quest_diagnostics"
    },
    {
      "displayName": "Quiktrip Corporation",
      "code": "quiktrip"
    },
    {
      "displayName": "Renovo Home Partners",
      "code": "renovo"
    },
    {
      "displayName": "Republic Services",
      "code": "republic_services"
    },
    {
      "displayName": "Roche USA",
      "code": "roche_usa"
    },
    {
      "displayName": "RWJ Barnabas Health",
      "code": "rwj_barnabas_health"
    },
    {
      "displayName": "Safelite Group",
      "code": "safelite_group"
    },
    {
      "displayName": "Safeway",
      "code": "safeway"
    },
    {
      "displayName": "Salesforce",
      "code": "salesforce"
    },
    {
      "displayName": "SC Johnson",
      "code": "sc_johnson"
    },
    {
      "displayName": "Sedgwick",
      "code": "sedgwick"
    },
    {
      "displayName": "Senior Lifestyle Corporation",
      "code": "senior_lifestyle"
    },
    {
      "displayName": "Sentara Healthcare",
      "code": "sentara_healthcare"
    },
    {
      "displayName": "Sherwin Williams Company",
      "code": "sherwin_williams"
    },
    {
      "displayName": "Southern Company",
      "code": "southern"
    },
    {
      "displayName": "Southwest Airlines Company",
      "code": "southwest_airlines"
    },
    {
      "displayName": "Sprouts Farmers Market",
      "code": "sprouts_farmers_market"
    },
    {
      "displayName": "St. Joseph Health",
      "code": "providence"
    },
    {
      "displayName": "Stage Stores",
      "code": "stage_stores"
    },
    {
      "displayName": "Starbucks Corporation",
      "code": "starbucks"
    },
    {
      "displayName": "State Farm",
      "code": "state_farm"
    },
    {
      "displayName": "Stellantis",
      "code": "stellantis"
    },
    {
      "displayName": "Sutter Health",
      "code": "sutter_health"
    },
    {
      "displayName": "Swedish Health Services",
      "code": "providence"
    },
    {
      "displayName": "Synnex Corporation",
      "code": "synnex"
    },
    {
      "displayName": "Sysco Corporation",
      "code": "sysco"
    },
    {
      "displayName": "Target Corporation",
      "code": "target"
    },
    {
      "displayName": "Temple University",
      "code": "temple_university"
    },
    {
      "displayName": "Tenet Healthcare Corporation",
      "code": "tenet_healthcare"
    },
    {
      "displayName": "Tenneco",
      "code": "tenneco"
    },
    {
      "displayName": "Tesla",
      "code": "tesla"
    },
    {
      "displayName": "Textron",
      "code": "textron"
    },
    {
      "displayName": "The Coca Cola Company",
      "code": "the_coca_cola"
    },
    {
      "displayName": "The Walt Disney Company",
      "code": "the_walt_disney"
    },
    {
      "displayName": "TJX Companies",
      "code": "tjx_companies"
    },
    {
      "displayName": "Trader Joes Company",
      "code": "trader_joes"
    },
    {
      "displayName": "Trinity Health Corporation",
      "code": "trinity_health"
    },
    {
      "displayName": "TTEC",
      "code": "ttec"
    },
    {
      "displayName": "Tyson Foods",
      "code": "tyson_foods"
    },
    {
      "displayName": "Ulta Beauty",
      "code": "ulta_beauty"
    },
    {
      "displayName": "Union Pacific Corporation",
      "code": "union_pacific"
    },
    {
      "displayName": "United Airlines Holdings",
      "code": "united_airlines_holdings"
    },
    {
      "displayName": "United States Steel Corporation",
      "code": "united_states_steel"
    },
    {
      "displayName": "Universal Health Services",
      "code": "universal_health_services"
    },
    {
      "displayName": "University System of Georgia",
      "code": "university_system_of_georgia"
    },
    {
      "displayName": "Unum",
      "code": "unum"
    },
    {
      "displayName": "UPMC",
      "code": "upmc"
    },
    {
      "displayName": "Verizon",
      "code": "verizon"
    },
    {
      "displayName": "Verra Mobility Corporation",
      "code": "verra_mobility"
    },
    {
      "displayName": "Vituity",
      "code": "vituity"
    },
    {
      "displayName": "W. W. Grainger",
      "code": "w_w_grainger"
    },
    {
      "displayName": "Wakefern Food Corporation",
      "code": "wakefern_food"
    },
    {
      "displayName": "Walmart",
      "code": "walmart"
    },
    {
      "displayName": "Waste Management",
      "code": "waste_management"
    },
    {
      "displayName": "Wegmans Food Markets",
      "code": "wegmans_food_markets"
    },
    {
      "displayName": "Wellspan Health",
      "code": "wellspan_health"
    },
    {
      "displayName": "Wellstar Health System",
      "code": "wellstar_health_system"
    },
    {
      "displayName": "Weyerhaeuser Company",
      "code": "weyerhaeuser"
    },
    {
      "displayName": "Whatabrands LLC",
      "code": "whatabrands"
    },
    {
      "displayName": "Whirlpool Corporation",
      "code": "whirlpool"
    },
    {
      "displayName": "Wiremold",
      "code": "legrand"
    },
    {
      "displayName": "Wood Group US Holdings",
      "code": "wood_group_us_holdings"
    },
    {
      "displayName": "Zappos",
      "code": "zappos"
    }
  ];

